<template>
  <div class="root">
    <div class="block">
      <p class="text-title">{{ title }}</p>
      <p class="text-content">{{ content }}</p>
    </div>
  </div>
</template>

<script>
import jsonData from "../assets/data.js";
export default {
  data() {
    return {
      title: jsonData[this.$route.query.pageType].title,
      content: jsonData[this.$route.query.pageType].content,
    };
  },
  beforeRouteUpdate(to, from, next) {
    next();
    this.title = jsonData[to.query.pageType].title;
    this.content = jsonData[to.query.pageType].content;
  },
};
</script>

<style lang="scss">
// app
@media screen and (max-width: 768px) {
  .root {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 100px 20px;
    .block {
      width: 100%;

      .text-title {
        font-size: 30px;
        text-align: center;
      }

      .text-content {
        font-size: 20px;
        margin-top: 100px;
        text-align: left;
        text-align-last: left;
        white-space: pre-line;
      }
    }
  }
}

// pc
@media screen and (min-width: 769px) {
  .root {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 100px 0;
    .block {
      width: 924px;

      .text-title {
        font-size: 30px;
        text-align: center;
      }

      .text-content {
        font-size: 20px;
        margin-top: 100px;
        text-align: left;
        text-align-last: left;
        white-space: pre-line;
      }
    }
  }
}
</style>
